import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const catchSputnikService = catchError((error) => {
    return throwError(getServerErrorMessage(error));
});

const getServerErrorMessage = (error: HttpErrorResponse) => {
    console.log(error);
    switch (error.status) {
        case 0 :
            return 'Se ha perdido la conexión a internet. Por favor recargue la pagina';
        case 422:
            if (error.error.errors instanceof Array) {
                return error.error.errors.join(', ');
            }
            return error;
        case 403:
            return 'No se pudo';
        case 500:
            if (error.error.errors instanceof Array) {
                return error.error.errors.join(', ');
            }
            return `${error.message}`;
        default:
            return `Error desconocido, por favor reintente`;
    }
};
